module.exports = {"id":"dp2_2l5q2","category":"2.2","text":"Digital Sharing","instructions":"Attribution links can be used to identify the owner of a piece of information or media online","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"questionType":"PickOne","random":false,"options":[{"id":"dp2_2l5q2-a1","text":"True","score":5.6},{"id":"dp2_2l5q2-a2","text":"Not sure","score":3.4},{"id":"dp2_2l5q2-a3","text":"False","score":3.4}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.2/l5q2.json
// module id = 1023
// module chunks = 41